import React from 'react'
import { Select, Input, DatePicker, Checkbox } from 'antd'

const Option = Select.Option
const { RangePicker } = DatePicker

class EditForm extends React.Component {
  static defaultProps = {
    columns: [],
  }

  _renderItem = (columns) => {
    const maps = new Map()
      .set('select', this._renderSelect)
      .set('date', this._renderDate)
      .set('text', this._renderText)
      .set('input', this._renderInput)
      .set('checkbox', this._renderCheckBox)
    return columns.map((v, idx) => {
      if (!v.label && !v.editType) {
        return null
      }
      return (
        <div key={idx} className={'zrs-editFormItem'}>
          <span className={'zrs-label'}>{v.label}：</span>
          {maps.get(v.editType)(v)}
        </div>
      )
    })
  }

  _renderCheckBox = (item) => {
    return <Checkbox onChange={item.onChange} />
  }

  _renderDate = (item) => {
    return (
      <RangePicker
        format="YYYY-MM-DD"
        onChange={item.onChange}
        value={item.value}
        clearIcon={false}
      />
    )
  }

  _renderText = (item) => <span>{item.text || item.value}</span>

  _renderInput = (item) => (
    <div style={{ display: 'inline-block' }}>
      <Input
        label={item.label}
        suffix={item.suffix}
        type={item.type}
        value={item.value}
        style={item.style}
        onChange={item.onChange}
      />
      {item.tipContent && (
        <span
          style={{ marginLeft: '10px', color: '#fa4c4c', fontSize: '14px' }}
        >
          {item.tipContent}
        </span>
      )}
    </div>
  )

  _renderSelect = (item) => {
    return (
      <Select style={item.style} value={item.value} onChange={item.onChange}>
        {item.options.map((v, idx) => (
          <Option key={v.value} value={v.value}>
            {v.text}
          </Option>
        ))}
      </Select>
    )
  }

  render() {
    return <div>{this._renderItem(this.props.columns)}</div>
  }
}

export default EditForm



// WEBPACK FOOTER //
// ./src/containers/CardManage/components/editForm.js